// IMPORTS
// Modules
import $ from 'jquery';
// OHS
import { OHSFormItem } from '../../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../../onehivesystems/js/OHSCRUD';


// COMPONENT
export default function ImportExport (props) {
   // Functions
   const importCSV = function () {
      const data = new FormData();
      data.append('file', $('#oneport-device-importexport-file')[0].files[0]);
      OHSCRUD({
         url: '/v1/oneport/ports/import/' + props.parent.deviceID,
         method: 'POST',
         payload: data,
         file: true,
         success: function (data) {
            props.parent.getPorts();
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         showSuccessPopup: true,
         confirmMessage: "Are you sure you wish to import this CSV file? This will overwrite all port data for this device with the data contained in the CSV file."
      });
   }
   const exportCSV = async function () {
      // Request CSV File
      const response = await fetch('/api/v1/oneport/ports/export/' + props.parent.deviceID);
      if (!response.ok) {
         props.onehive.setPopup({
            display: true,
            title: "Server Error",
            message: "The server experienced an error when trying to generate the CSV file. Please try again!",
            severity: 'error',
            timespan: 5
         })
      } else {
         // Build File Data
         const blob = await response.blob();

         // Download CSV File
         const url = window.URL.createObjectURL(blob);
         const link = document.createElement('a');
         link.href = url;
         link.setAttribute('download', props.parent.deviceID + '.csv');
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
      }
   }

   // Component
   return (
      <div id='oneport-device-importexport' className='oneport-device-importexport'>
         <OHSFormItem onehive={props.onehive} title="Export CSV">
            <button className='ohsbtn-success' onClick={exportCSV}>Export</button>
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Import CSV">
            <input id='oneport-device-importexport-file' type='file' className='ohsinput' />
            <button type="submit" className='ohsbtn' onClick={importCSV}>Import</button>
         </OHSFormItem>
      </div>
   );
}